import { HasAccess } from 'components';
import React, { useCallback } from 'react';
import { ADMIN_ROUTES } from 'constants/routes';
import { PERMISSIONS } from 'constants/permissions';
import { Tasks } from 'components/common/tasks/tasks';
import { useNavigate, useParams } from 'react-router-dom';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const CountryTasks = React.memo(() => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { hasAccess } = useAccessControl();
  const onAdd = useCallback(
    () =>
      navigate(ADMIN_ROUTES.country.createTask, {
        state: {
          entityName: 'COUNTRY',
          entityId: id,
        },
      }),
    [navigate, id]
  );
  const onRedirectToTask = useCallback(
    (value: string) => navigate(`${ADMIN_ROUTES.country.view}/${id}/tasks/${value}`),
    [navigate, id]
  );
  return (
    <HasAccess role={PERMISSIONS.tasks.task.read}>
      <Tasks
        entityType="COUNTRY"
        entityId={id}
        hasAccessToWrite={hasAccess(PERMISSIONS.tasks.task.write)}
        hasAccessToDelete={hasAccess(PERMISSIONS.tasks.task.delete)}
        showAnalytics={false}
        onTaskAdd={onAdd}
        onRedirectToTask={onRedirectToTask}
      />
    </HasAccess>
  );
});
